import _ from 'lodash';

type Sample = { x: number; y: number };

/**
 * Recentres one ECG template waveform vertically inside its preview box. Takes the highest and lowest y across the samples and shifts every point down by half the leftover vertical space, returning the shifted points wrapped as a single series.
 *
 * @param samples - Waveform points to recentre.
 * @param height - Preview box height the points are centred within.
 * @returns A single-element array holding the shifted sample points.
 */
const meanSample = (samples: Sample[], height = 146) => {
  const max = _.maxBy(samples, 'y').y;
  const min = _.minBy(samples, 'y').y;
  return [
    _.map(samples, (item) => ({
      x: item.x,
      y: item.y + Math.round((height - max - min) / 2),
    })),
  ];
};

export default meanSample;
